import { PageContainer } from "@ant-design/pro-components";
import { CompanyInformation } from "components";

export const CreateCompanyPage = () => (
  <PageContainer>
    <CompanyInformation />
  </PageContainer>
);
